import PostEditorLayout from "../components/PostEditorLayout";
import useCategories from "../hooks/useCategories";
import usePostForm from "../hooks/usePostForm";
import { useParams } from "react-router-dom";

export default function EditPostPage() {

    const {categories } = useCategories();

    console.log("EditPostPage rendered");

    const { postId } = useParams();

    console.log("postId:", postId);

    const {
        formData,
        updateField,
        imagePreview,
        handleImageChange,
        ogImagePreview,
        handleOgImageChange,
        submit,
        saving,
    } = usePostForm({
        mode: "edit",
        postId,
    });

    console.log(formData)

    

    return (
        <PostEditorLayout
            title="Edit Post"
            subtitle="Content Management"
            buttonLabel="Update Post"
            onSubmit={submit}
            saving={saving}
            formData={formData}
            updateField={updateField}
            imagePreview={imagePreview}
            onImageChange={handleImageChange}
            ogImagePreview={ogImagePreview}
            onOgImageChange={handleOgImageChange}
            categories={categories}
        />
    );
}